import React, { FC, useEffect, useState } from "react";
import { API_URL } from "../../../../actions/settings";
import { IonCol, IonRow } from "@ionic/react";

async function getSuggestions(token: string, id: any) {
  return fetch(`${API_URL}/benchmark/suggested_rates/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
    return res.json();
  });
}

interface IProps {
    id : string | null | undefined;
};

interface Suggestion {
    "median_kwh_per_sqft": number,
    "median_therms_per_sqft": number,
    "min_kwh_per_sqft": number,
    "max_kwh_per_sqft": number,
    "min_therms_per_sqft": number,
    "max_therms_per_sqft": number
}

const defaultSuggestion = {
    "median_kwh_per_sqft": 0,
    "median_therms_per_sqft": 0,
    "min_kwh_per_sqft": 0,
    "max_kwh_per_sqft": 0,
    "min_therms_per_sqft": 0,
    "max_therms_per_sqft": 0
}

const AnnualEnergyTargetSuggestions:FC<IProps> = (props) => {
    const { id } = props;
    const [ suggestions, setSuggestions ] = useState<Suggestion>(defaultSuggestion);        


    useEffect(() => {
        const fetchSuggestions = async () => {
            const token = `Token ${(localStorage.getItem("token") || "").slice(1, -1)}`;
            const res = await getSuggestions(token, id);            
            if (res.status !== "error") {
                setSuggestions(res.data);
            }
        };

        fetchSuggestions();
    }, [id]);


    return <IonRow>
        <IonCol sizeMd="8" style={{border:'3px solid #444', 
            backgroundColor:'#444', 
            padding:'1rem', 
            margin:'1rem 0',
            borderRadius:'8px'}}>
            <div style={{textAlign:'center', marginBottom:'0.5rem', fontSize:'1.2rem', fontWeight:'bold'}}>
                Similar AI Buildings
            </div>
            <IonRow>
                <IonCol style={{border:'2px solid #888',margin:'0.2rem',padding:'0.5rem',borderRadius:'5px'}}>
                    <div style={{textAlign:'center',fontWeight:'bold', marginBottom:'0.5rem'}}>Min</div>
                    <div style={{padding:'0.2rem'}}>{suggestions.min_kwh_per_sqft.toFixed(2)} kWh/ft<sup>2</sup> </div>
                    <div style={{padding:'0.2rem'}}>{suggestions.min_therms_per_sqft.toFixed(2)} therms/ft<sup>2</sup></div>
                </IonCol>
                <IonCol style={{border:'2px solid #888',margin:'0.2rem',padding:'0.5rem',borderRadius:'5px'}}>
                    <div style={{textAlign:'center',fontWeight:'bold', marginBottom:'0.5rem'}}>Median</div>
                    <div style={{padding:'0.2rem'}}>{suggestions.median_kwh_per_sqft.toFixed(2)} kWh/ft<sup>2</sup> </div>
                    <div style={{padding:'0.2rem'}}>{suggestions.median_therms_per_sqft.toFixed(2)} therms/ft<sup>2</sup></div>
                </IonCol>
                <IonCol style={{border:'2px solid #888',margin:'0.2rem',padding:'0.5rem',borderRadius:'5px'}}>
                    <div style={{textAlign:'center',fontWeight:'bold', marginBottom:'0.5rem'}}>Max</div>
                    <div style={{padding:'0.2rem'}}>{suggestions.max_kwh_per_sqft.toFixed(2)} kWh/ft<sup>2</sup> </div>
                    <div style={{padding:'0.2rem'}}>{suggestions.max_therms_per_sqft.toFixed(2)} therms/ft<sup>2</sup></div>
                </IonCol>
            </IonRow>
        </IonCol>
    </IonRow>
};

export default AnnualEnergyTargetSuggestions;